import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { TextField } from "@material-ui/core";
import colors from "../../constants/colors";

interface InvoiceEditNoteDialogProps {
	//The note to be edited in the dialog.
	note: string;
	//The callback method for setting the new note.
	setNote: (newNote: string) => void;
}

const useStyles = makeStyles(() => ({
	button: {
		display: "flex",
		justifyContent: "center",
		marginTop: 10,
		marginBottom: 10,
	},
}));

/**
 * This component is displayed in the dialog on the invoice details page and is meant for editing the invoice note.
 * It takes in the original note as well as a callback method for setting the new note upon submission.
 * @param props
 */
export const InvoiceEditNoteDialog = (props: InvoiceEditNoteDialogProps) => {
	const classes = useStyles();
	const [note, setNote] = React.useState(props.note);
	const [noteToSet, setNoteToSet] = React.useState(props.note);
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNoteToSet(event.target.value);
	};
	return (
		<div style={{ minWidth: 600 }}>
			<div data-testid={"invoice-note-display"}>
				<TextField
					value={noteToSet}
					multiline
					rows={10}
					style={{
						width: "90%",
						margin: "auto",
						border: "1px solid gray",
						marginTop: 10,
						display: "flex",
						justifyContent: "center",
						backgroundColor: colors.gray100,
					}}
					onChange={handleChange}
				></TextField>
			</div>
			<div className={classes.button}>
				<Button
					size="small"
					variant="contained"
					color={"primary"}
					onClick={() => {
						setNote(noteToSet);
						props.setNote(noteToSet);
					}}
					disabled={noteToSet === note}
					data-testid="edit-note-button"
				>
					{"Submit Changes"}
				</Button>
			</div>
		</div>
	);
};
